<script>
  import Img from '@components/Img';
  export let link, cover, title = '', desc = '', pub_date
</script>
<div class="news-item">
  <a href={link}>
    {#if cover}
      <Img
        src={cover}
        alt={title}
        type='smallHeight'
      />
    {/if}
    {#if title}
      <div class="title">
        <span>{title}</span>
      </div>
    {/if}
    {#if desc}
      <div class="description">
        <span>{desc}</span>
      </div>
    {/if}
    {#if pub_date}
      <div class="date">{pub_date}</div>
    {/if}
  </a>
</div>

<style>
  .news-item {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #C4C4C4;
    a {
      color: black;
      text-decoration: none;
      :hover {
        text-decoration: none;
      }
    }
    .image {
      color: #000000;
      img {
        width: 100%;
      }
    }
    .title {
      line-height: 37px;
      font-size: 24px;
      letter-spacing: 0.05em;
      margin-top: 30px;
      text-transform: uppercase;
    }
    .description {
      line-height: 32px;
      font-size: 18px;
      letter-spacing: 0.05em;
      margin-top: 40px;
      font-family: "Myriad Pro Light";
    }
    .date {
      line-height: 18px;
      font-size: 15px;
      letter-spacing: 0.05em;
      text-align: left;
      margin-top: 40px;
    }
  }
</style>
